module.exports = __webpack_public_path__ + "c2cdcc76c9b104baac8e679ac608d1b4.png";


//////////////////
// WEBPACK FOOTER
// ./application/adminlte/plugins/iCheck/minimal/grey.png
// module id = 307
// module chunks = 0